var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 15.001 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    paintOrder: "stroke fill markers",
    fillRule: "evenodd",
    d: "M14.984 6.662l-1.5-4a.25.25 0 0 0-.234-.162H10V1.48C10 .664 9.32 0 8.483 0H1.516C.68 0 0 .664 0 1.48v8.645c0 .482.392.875.875.875h1.217c.207.58.757 1 1.408 1 .65 0 1.2-.42 1.408-1h5.684c.207.58.757 1 1.408 1 .651 0 1.2-.42 1.408-1h.717a.876.876 0 0 0 .875-.875V6.75c0-.03-.006-.06-.016-.088zM.5 1.48C.5.94.956.5 1.516.5h6.967c.56 0 1.017.44 1.017.98v1.23c0 .008.003.013.004.02 0 .007-.004.013-.004.02V8h-9V1.48zm3 10.02a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2zm8.5 0a1 1 0 1 1 .002-2.002A1 1 0 0 1 12 11.5zm2.5-1.375a.375.375 0 0 1-.375.375H13.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5H5C5 9.673 4.327 9 3.5 9S2 9.673 2 10.5H.875a.375.375 0 0 1-.375-.375V8.5h9.25a.25.25 0 0 0 .25-.25V3h3.076L14.5 6.795v3.33zM11 3.75a.25.25 0 0 0-.5 0v2.5c0 .138.112.25.25.25h2.5a.25.25 0 1 0 0-.5H11V3.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.128ff50666891687042ddf4e3ee10222.svg";
export { ForwardRef as ReactComponent };